import React from "react";

const CartIcon = () => {
  return (
    <>
      <svg
      className="nav-icon"
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.8 28.8C26.802 28.8 25.2 30.402 25.2 32.4C25.2 33.3548 25.5793 34.2705 26.2544 34.9456C26.9295 35.6207 27.8452 36 28.8 36C29.7548 36 30.6705 35.6207 31.3456 34.9456C32.0207 34.2705 32.4 33.3548 32.4 32.4C32.4 31.4452 32.0207 30.5295 31.3456 29.8544C30.6705 29.1793 29.7548 28.8 28.8 28.8ZM0 0V3.6H3.6L10.08 17.262L7.632 21.672C7.362 22.176 7.2 22.77 7.2 23.4C7.2 24.3548 7.57928 25.2705 8.25442 25.9456C8.92955 26.6207 9.84522 27 10.8 27H32.4V23.4H11.556C11.4367 23.4 11.3222 23.3526 11.2378 23.2682C11.1534 23.1838 11.106 23.0693 11.106 22.95C11.106 22.86 11.124 22.788 11.16 22.734L12.78 19.8H26.19C27.54 19.8 28.728 19.044 29.34 17.946L35.784 6.3C35.91 6.012 36 5.706 36 5.4C36 4.92261 35.8104 4.46477 35.4728 4.12721C35.1352 3.78964 34.6774 3.6 34.2 3.6H7.578L5.886 0M10.8 28.8C8.802 28.8 7.2 30.402 7.2 32.4C7.2 33.3548 7.57928 34.2705 8.25442 34.9456C8.92955 35.6207 9.84522 36 10.8 36C11.7548 36 12.6705 35.6207 13.3456 34.9456C14.0207 34.2705 14.4 33.3548 14.4 32.4C14.4 31.4452 14.0207 30.5295 13.3456 29.8544C12.6705 29.1793 11.7548 28.8 10.8 28.8Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default CartIcon;
